<template>
  <div>
    <div class="record-count-container">
      <div class="record-count-item">
        <img src="@/assets/images/fuelCar/all-car.png" alt="">
        <div class="count_card">
          <div class="num all">{{ recordData.sum || 0 }}</div>
          <div class="label">总机械数</div>
        </div>
      </div>
      <div class="record-count-item">
        <img src="@/assets/images/fuelCar/success-car.png" alt="">
        <div class="count_card">
          <div class="num success">{{ recordData.successRecord || 0 }}</div>
          <div class="label">备案成功数</div>
        </div>
      </div>
      <div class="record-count-item">
        <img src="@/assets/images/fuelCar/fail-car.png" alt="">
        <div class="count_card">
          <div class="num fail">{{ recordData.failedRecord || 0 }}</div>
          <div class="label">备案失败数</div>
        </div>
      </div>
      <div class="record-count-item">
        <img src="@/assets/images/fuelCar/wait-car.png" alt="">
        <div class="count_card">
          <div class="num warning">{{ recordData.noRecord || 0 }}</div>
          <div class="label">未备案数</div>
        </div>
      </div>
    </div>

    <!-- 搜索区域 -->
    <nx-search ref="searchForm" :source="searchForm" :config="searchConfig" @hiddenChange="hiddenChange">
      <div slot="search">
        <el-button type="primary" @click="reset()">查询</el-button>
        <el-button @click="reset(1)">重置</el-button>
      </div>
    </nx-search>
    <!-- 列表区域 -->
    <nx-table ref="nxTable" table-title="机械备案列表" :data="tableData" @search="search">
      <template slot="operation">
        <el-button v-perm="'/notRoadFour/machineRecord/batchDeleteRecord'" type="primary"
          @click="batchDeleteRecord({ status: true, type: 'delete' })">批量删除备案
        </el-button>
        <el-button v-perm="'/notRoadFour/machineRecord/batchRecord'" type="primary" @click="batchRecord">批量备案
        </el-button>
        <el-button v-perm="'/notRoadFour/machineRecord/export'" type="primary" plain icon="iconfont
          icon-daochu_blue" @click="handExport()">导出
        </el-button>
      </template>

      <el-table-column type="selection"></el-table-column>
      <el-table-column label="机械环保代码" prop="vehicleFrameNo"></el-table-column>
      <el-table-column label="T-BOX 设备编号" prop="tboxSn"></el-table-column>
      <el-table-column label="终端型号" prop="tboxType"></el-table-column>
      <el-table-column label="芯片型号" prop="chipModel"></el-table-column>
      <el-table-column label="芯片ID" prop="chipId"></el-table-column>
      <el-table-column label="排放水平" prop="emissionLevelType">
        <template slot-scope="{row}">
          {{
              {
                4: '国四'
              }[row.emissionLevelType]
          }}
        </template>
      </el-table-column>
      <el-table-column label="激活模式" prop="isActivateStr"></el-table-column>
      <el-table-column label="备案平台" prop="recordPlateType">
        <template slot-scope="{row}">
          {{
              {
                1: '非道路机械国家平台'
              }[row.recordPlateType]
          }}
        </template>
      </el-table-column>
      <el-table-column label="备案时间" prop="recordTime" width="160">
        <template slot-scope="{row}">
          {{ $utils.formatDate(row.recordTime) }}
        </template>
      </el-table-column>
      <el-table-column label="备案状态" prop="recordStatus">
        <template slot-scope="{row}">
          <span
            :class="{ 1: 'nx-text-warning', 2: 'nx-text-warning', 3: 'nx-text-success', 4: 'nx-text-danger',
             5: 'nx-text-warning',6: 'nx-text-success', 7: 'nx-text-danger' }[row.recordStatus]">
            {{ (machineRecordResultTypes.find((item) => item.value === row.recordStatus) || {}).label || '' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="备注" prop="remark"></el-table-column>
      <!-- <el-table-column label="操作" prop="operation"></el-table-column> -->
      <el-table-column label="操作" fixed="right" width="80">
        <template slot-scope="{row}">
          <el-button v-if="[2, 4, 6].includes(row.recordStatus)" v-perm="'/notRoadFour/machineRecord/record'" type="text"
            @click="submitRecord(row.vehicleFrameNo)">备案
          </el-button>
          <el-button v-if="[3,7].includes(row.recordStatus)" v-perm="'/notRoadFour/machineRecord/deleteRecord'"
            type="text" @click="deleteRecord({ status: true, type: 'delete', vehicleFrameNo: row.vehicleFrameNo })">删除备案
          </el-button>
        </template>
      </el-table-column>
    </nx-table>
    <submit-dialog :id="dialogConfig.vehicleFrameNo" :type="dialogConfig.type" :visible.sync="dialogConfig.status"
      @onConfirm="$refs.nxTable.search()"></submit-dialog>
  </div>
</template>
  
  <script>

import {
  getMachineRecordList,
  getRecordData,
  submitRecord,
  getMachineRecordExport
} from '@/api/notRoadFour/machineRecord';
import SubmitDialog from './components/submitDialog.vue';
import { machineRecordResultTypes, isActivateTypes, recordPlatforms } from '../config/types'
export default {
  name: 'MachineRecord',
  components: {
    SubmitDialog
  },
  props: {},
  data() {
    return {
      tableData: [], //列表数据源
      machineRecordResultTypes, //备案状态
      recordData: {},
      searchForm: {
        vehicleFrameNo: '', //机械环保代码
        recordStatus: [], //备案状态
        recordPlate: [], //备案平台
        tboxType: '', //终端型号
        chipModel: '', //芯片型号
        tboxSn: '', //T-BOX 设备编号
        chipId: '', //芯片ID
      },
      dialogConfig: {
        status: false,
        vehicleFrameNo: '',
        type: ''
      }
    }
  },
  computed: {
    searchConfig() {
      return [
        {
          key: 'vehicleFrameNo',
          component: 'el-input',
          span: 8,
          label: '机械环保代码:',
          props: {
            clearable: true,
            placeholder: '请输入机械环保代码'
          }
        },
        {
          key: 'recordStatus',
          component: 'el-select',
          span: 8,
          label: '备案状态:',
          data: [{ value: '', label: '全部' }, ...machineRecordResultTypes]
        },
        {
          key: 'recordPlate',
          component: 'el-select',
          span: 8,
          label: '备案平台:',
          data: [{ value: '', label: '全部' }, ...recordPlatforms]
        },
        {
          key: 'tboxType',
          component: 'el-input',
          span: 8,
          label: '终端型号:',
          props: {
            clearable: true,
            placeholder: '请输入终端型号'
          }
        },
        {
          key: 'chipModel',
          component: 'el-input',
          label: '芯片型号:',
          span: 8,
          props: {
            clearable: true,
            placeholder: '请输入芯片型号',
            maxlength: 30
          }
        },
        {
          key: 'tboxSn',
          component: 'el-input',
          span: 8,
          label: 'T-BOX 设备编号:',
          props: {
            clearable: true,
            placeholder: '请输入T-BOX 设备编号'
          }
        },
        {
          key: 'chipId',
          component: 'el-input',
          label: '芯片ID:',
          span: 8,
          props: {
            clearable: true,
            placeholder: '请输入芯片ID',
            maxlength: 16
          }
        },
        {
          component: 'slot',
          slotName: 'search',
          span: 16
        }
      ]
    }
  },
  created() {
    this.getRecordData();
  },
  methods: {
    // 收起筛选条件时重新计算table高度
    hiddenChange() {
      this.$refs.nxTable.getTableHeight();
    },
    // 搜索
    async search(pagination) {
      const { pageNum, pageSize } = pagination;
      const params = {
        ...this.searchForm,
        pageNum,
        pageSize,
      };
      const { data } = await getMachineRecordList(params);
      this.tableData = data.list.map(item => ({
        ...item,
        isActivateStr: isActivateTypes.find(type => type.value === item.isActivate)?.label,
      }));
      pagination.total = data.total;
    },
    //查询
    reset(type) {
      if (type) {
        this.$refs.searchForm.resetFields();
      } else {
        this.getRecordData();
        this.$refs.nxTable.search(1);
      }
    },
    // 获取搜索栏上方的车辆备案数据
    async getRecordData() {
      const { data } = await getRecordData();
      this.recordData = data;
    },
    //批量删除备案
    batchDeleteRecord({ status = false, type }) {
      const selection = this.$refs.nxTable.$refs.table.selection;
      const vehicleFrameNo = selection.map((item) => item.vehicleFrameNo).join(',');
      if (!vehicleFrameNo) {
        this.$message.warning('请选择机械');
        return;
      }
      this.dialogConfig = {
        status,
        vehicleFrameNo,
        type
      };
    },
    //删除备案
    async deleteRecord({ status = false, type, vehicleFrameNo }) {

      if (!vehicleFrameNo) {
        this.$message.warning('请选择机械');
        return;
      }
      this.dialogConfig = {
        status,
        vehicleFrameNo,
        type
      };

    },
    //批量备案
    batchRecord() {
      const selection = this.$refs.nxTable.$refs.table.selection;
      const vehicleFrameNo = selection.map((item) => item.vehicleFrameNo).join(',');
      if (!vehicleFrameNo) {
        this.$message.warning('请选择机械');
        return;
      }
      this.submitRecord(vehicleFrameNo, 'batch');
    },
    // 提交备案
    async submitRecord(vehicleFrameNo, type = '') {
      const confirm = await this.$confirm('备案成功后，机械信息将无法修改，继续备案吗？', '操作', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      });
      if (confirm !== 'confirm') return;
      const result = await submitRecord(vehicleFrameNo).catch((err) => {
        if (type === 'batch') {
          const len = vehicleFrameNo.split(',').length;
          this.toggleFailedDialog({
            status: true,
            tableData: err?.data?.failDetail || [],
            all: len,
            success: err?.data?.success || 0,
            failed: err?.data?.fail || 0
          });
        }
        return;
      });
      if (!result) return;
      this.$message.success('操作成功');
      this.$refs.nxTable.search();
    },

    toggleFailedDialog(config) {
      this.failedDialogConfig = config;
    },

    //导出
    async handExport() {
      const params = {
        ...this.searchForm,
      };
      await getMachineRecordExport(params);
      this.$message.success('导出任务已提交，请前往导出文件列表查看！');
    }
  }
}
</script>
  
  <style scoped lang="scss">
  .record-count-container {
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
  
    .record-count-item {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #fff;
      padding: 15px 40px;
      border-radius: 4px;
  
      img {
        width: 90px;
        height: 90px;
      }
  
      &:not(:last-child) {
        margin-right: 20px;
      }
  
      >i {
        font-size: 40px;
        margin-right: 15px;
      }
  
      .count_card {
        .num {
          font-size: 32px;
        }
  
        .label {
          font-size: 12px;
        }
      }
  
      .all {
        color: #0080F6;
      }
  
      .success {
        color: #67C23A;
      }
  
      .fail {
        color: #F56C6C;
      }
  
      .warning {
        color: #E6A23C;
      }
    }
  }
  </style>